import React, { useEffect } from 'react';
import './App.css';
import Hero from './components/Hero';
import About from './components/About';
import Products from './components/Products';
import Mission from './components/Mission';
import Contact from './components/Contact';

function App() {
  useEffect(() => {
    const trackVisit = async () => {
      try {
        const response = await fetch('/api/tracking/request-token', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            page_url: window.location.href
          })
        });
        const data = await response.json();
        if (data.success) {
          localStorage.setItem('tracking_token', data.token);
        }
      } catch (error) {
        console.error('Tracking failed:', error);
      }
    };
    trackVisit();
  }, []);

  return (
    <div className="App">
      <Hero />
      <About />
      <Products />
      <Mission />
      <Contact />
    </div>
  );
}

export default App;
